import {useEffect} from 'react';

const isSaltEdgeOrigin = (origin) => {
  try {
    return new URL(origin).hostname.endsWith('saltedge.com');
  } catch {
    return false;
  }
};

export const useSaltEdge = ({onSuccess, onClose} = {}) => {
  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.type === 'salt_edge_return') {
        const connectionId = event?.data?.connection_id;
        if (connectionId) {
          onSuccess?.({connectionId});
        } else {
          onClose?.();
        }
        return;
      }
      if (event?.data === 'cancel') {
        onClose?.();
      }
      if (!isSaltEdgeOrigin(event.origin)) return;

      try {
        const payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (!payload?.data) return;

        const {state} = payload.data;

        if (state === 'error') {
          onClose?.();
        }
      } catch {
        // ignore malformed messages
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onClose, onSuccess]);
};
